import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_HEALTHCARE_PROVIDER } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const deleteHealthcareProvider = createAsyncThunk(
  "healthcareProviders/delete-healthcare-provider",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.delete(URL_HEALTHCARE_PROVIDER + "/" + data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { deleteHealthcareProvider };
